import { useState } from 'react'

import { EMPTY_STRING } from '../../../../constants/common'

export function useSelectSearch({
  initialValue = EMPTY_STRING,
  maxLength,
  onChangeSearch,
}) {
  const [searchValue, setSearchValue] = useState(initialValue)

  function handleClearSearch() {
    onChangeSearch?.(null)

    setSearchValue(EMPTY_STRING)
  }

  function handleChangeSearch(nextValue) {
    if (!maxLength || nextValue.length <= maxLength) {
      onChangeSearch?.(nextValue)

      setSearchValue(nextValue)
    }
  }

  return {
    handleChangeSearch,
    handleClearSearch,
    searchValue,
  }
}
